<div id="main-content" class="wrapper has-padding margin-height zoom-margin" (focusout)="onFocusOutMainContent($event)">
  @if (employmentData ) {
    <form [formGroup]="employmentForm" (ngSubmit)="onSubmit()">
      <h1 #target class="bofa--heading is-4">Employment history</h1>
      @if (employmentData.lockBox) {
        <div>
          <p>
            <mat-checkbox formControlName="noEmploymentHistory" aria-required="true">
              <mat-label><span class="white-space-normal">{{noEmploymentHistoryInstruction}}</span>
            </mat-label>
          </mat-checkbox>
        </p>
      </div>
    }
    @if (!noEmploymentHistory.value) {
      <div>
        <div [class.changeDisplay]="employmentChange" class="flex-container">
          <mat-card appearance="outlined" class="af-mat-card mat-elevation-z bottom-space fx-flex-50">
            <mat-card-header>
              <div mat-card-avatar class="example-header-image">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="img-size" aria-label="information icon">
                  <g data-name="ICON OUTLINES">
                    <path fill="#012169" d="M12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Zm0,19a9,9,0,1,1,9-9A9.01,9.01,0,0,1,12,21Z" transform="translate(-2 -2)"/>
                    <path fill="#012169" d="M11.992,6.848a.632.632,0,0,0-.617.64.625.625,0,0,0,1.25,0A.635.635,0,0,0,11.992,6.848Z" transform="translate(-2 -2)"/>
                  <rect fill="#012169" x="9.5" y="7" width="1" height="8"/></g>
                </svg>
              </div>
              <mat-card-title>Account for all employment gaps</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              @if (employmentData.employmentLimit != 55) {
                <p class="bofa--heading is-9 global-red">The
                  employment history must
                  reflect all periods of employment or unemployment for the last {{employmentData.employmentLimit}} years,
                in chronological order, starting with your most recent job.</p>
              }
              @if (employmentData.employmentLimit == 55) {
                <p class="bofa--heading is-9 global-red">Please
                  enter 10 years of
                  employment history, in chronological order, starting with your most recent job. If you are currently
                  unemployed, enter that period of time as an Employment Break. Employment history must reflect all periods
                of employment or unemployment for the last 10 years.</p>
              }
              @if (employmentGapInstruction == 1 && employmentBreakList.length>0) {
                <div>
                  <a target="_blank" rel="noopener noreferrer" (click)="clickEmploymentGapInstructions()"
                    class="bold global-red" href="assets/OUS Employment Gap Instructions.docx"
                  aria-label="employment gap instructions">Employment Gap Instructions </a>
                </div>
              }
            </mat-card-content>
          </mat-card>
          <mat-card appearance="outlined" class="af-mat-card mat-elevation-z bottom-space fx-flex-50">
            <mat-card-header>
              <div mat-card-avatar class="example-header-image">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="img-size" aria-label="information icon">
                  <g data-name="ICON OUTLINES">
                    <path fill="#012169" d="M12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Zm0,19a9,9,0,1,1,9-9A9.01,9.01,0,0,1,12,21Z" transform="translate(-2 -2)"/>
                    <path fill="#012169" d="M11.992,6.848a.632.632,0,0,0-.617.64.625.625,0,0,0,1.25,0A.635.635,0,0,0,11.992,6.848Z" transform="translate(-2 -2)"/>
                  <rect fill="#012169" x="9.5" y="7" width="1" height="8"/></g>
                </svg>
              </div>
              <mat-card-title>Currently unemployed?</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <p class="bofa--heading is-9">Use the 'Add break' button to account for this period of time</p>
            </mat-card-content>
          </mat-card>
        </div>
        <div [class.changeDisplay]="employmentChange" class="flex-container">
          <div class="flex-change fx-flex-40">
            @if (hasEmploymentHistory()) {
              <h2 class="bofa--heading is-6 flex-heading">Enter your employment history
              </h2>
            }
            @if (jobCountry == 'IND') {
              <div>
                <p>
                  <span class="mat-hint-italic margin-notop minor-list-space">If you do not want us to initiate the
                    verification for your most recent employment immediately, please select the date after which the
                    employment verification should be initiated.
                    <ul class="has-no-padding has-no-margin">
                      <li><strong>(This should be minimum 8 business days prior to the scheduled date of joining) Note:
                      Candidates will join only after a satisfactory employment verification report.)</strong> </li>
                    </ul>
                  </span>
                </p>
                <mat-form-field class="max-zoom field-space width-350">
                  <input matInput [matDatepicker]="employmentVerificationDatePicker" time="false" [min]="minDate"
                    formControlName="employmentVerificationDate" maxlength="100">
                    <mat-datepicker-toggle matSuffix [for]="employmentVerificationDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #employmentVerificationDatePicker></mat-datepicker>
                    <mat-hint>Format mm/dd/yyyy</mat-hint>
                  </mat-form-field>
                </div>
              }
              @for (employmentForm of employmentList.controls; track employmentForm; let i = $index) {
                <div [formGroup]="employmentForm">
                  <div>
                    @if (stepEmployment === i) {
                      <mat-accordion multi="true">
                        <mat-expansion-panel [class.border]="borderEmpHistory" [expanded]="stepEmployment === i"
                          [hideToggle]="true" (opened)="setEmploymentStep(i)" class="af-mat-card mat-elevation-z panel-width">
                          <mat-expansion-panel-header class="mat-expansion outlined background-color-rgba">
                            <mat-panel-title>
                              Employer {{i + 1}}
                            </mat-panel-title>
                            <mat-panel-description>
                              <div class="float-cursor-margin">
                                <button type="button" (keyup.enter)="deleteEmploymentClick(i, $event)" (click)="deleteEmploymentClick(i, $event)" class="icon-button">
                                  <svg class="height-width" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-label="remove employment">
                                    <g data-name="24 x 24 BOX">
                                      <rect fill="none" width="24" height="24"/>
                                    </g>
                                    <g data-name="ICON OUTLINE">
                                    <polygon fill="#e31837" class="cls-2" points="21 3.707 20.293 3 12 11.293 3.707 3 3 3.707 11.293 12 3 20.293 3.707 21 12 12.707 20.293 21 21 20.293 12.707 12 21 3.707"/></g>
                                  </svg>
                                  <span class="bofa--skiplink">icon</span>
                                </button>
                              </div>
                            </mat-panel-description>
                          </mat-expansion-panel-header>
                          <!-- set focus when pressing Add button -->
                          <div tabindex="-1" #addEmploymentHistoryElement class="bofa--skiplink">
                          </div>
                          <p class="bofa--heading is-8 bold ">(1 of {{sections}}) Important details</p>
                          <div class="bottom-space">
                            <div id="isCurrentEmployer-radio-group" class="minor-list-space"><span><abbr title="required">*
                            </abbr>Is this your current employer?</span>
                          </div>
                          <mat-radio-group aria-label="Select an option" class="bottom-space"
                            (focusout)="currentOnBlur(employmentForm)" (focusin)="currentOnFocus(employmentForm)"
                            aria-describedby="isCurrentEmployer-radio-group"
                            (change)="isCurrentEmployerChanges(employmentForm)" formControlName="isCurrentEmployer" required>
                            <mat-radio-button value="1" name="isCurrentEmployer"
                            class="minor-list-space radio-padding field-space">Yes</mat-radio-button>
                            <mat-radio-button value="0" name="isCurrentEmployer">No</mat-radio-button>
                            @if (submit.value && employmentForm.controls.isCurrentEmployer.hasError('required') || employmentForm.controls.checkIsCurrentEmployer.value) {
                              <mat-error
                                >
                              Please select Is this your current employer?</mat-error>
                            }
                          </mat-radio-group>
                        </div>
                        @if (employmentForm.controls.isCurrentEmployer.value == 1) {
                          <div class="bottom-space">
                            <div id="isNoticePeriodRequired-radio-group" class="minor-list-space"><span><abbr title="required">*
                            </abbr>When you tender your resignation with your current employer, will you be required to work
                          a notice period before beginning employment with Bank of America?</span>
                        </div>
                        <mat-radio-group aria-label="Select an option" class="bottom-space"
                          (focusout)="haveNoticePeriodOnBlur(employmentForm)"
                          (focusin)="haveNoticePeriodOnFocus(employmentForm)"
                          aria-describedby="isNoticePeriodRequired-radio-group"
                          (change)="isNoticePeriodChange(employmentForm)" formControlName="noticePeriod" required>
                          <mat-radio-button value="1" name="noticePeriod"
                            class="minor-list-space radio-padding field-space">Yes
                          </mat-radio-button>
                          <mat-radio-button value="0" name="noticePeriod">No</mat-radio-button>
                          @if (submit.value && employmentForm.controls.noticePeriod.hasError('required') || employmentForm.controls.checkNoticePeriod.value) {
                            <mat-error
                              >
                              Please select When you tender your resignation with your current employer, will you be required
                            to work a notice period before beginning employment with Bank of America?</mat-error>
                          }
                        </mat-radio-group>
                      </div>
                    }
                    @if (employmentForm.controls.noticePeriod.value == 1) {
                      <div>
                        <!-- we need to ensure only for U.S condidate
                        apply that flag to show and hide the notice period question -->
                        @if (true) {
                          <div class="bottom-space">
                            <mat-form-field hideRequiredMarker>
                              <mat-label id="noticePeriod-label"><abbr title="required">* </abbr><span>What is your required
                              notice period? (in
                            days)</span></mat-label>
                            <input matInput [value]="employmentForm.controls.noticePeriodDays.value"
                              formControlName="noticePeriodDays" type="text" maxlength="3" min="0" max="120" required
                              aria-labelledby="noticePeriod-label" aria-required="true">
                            </mat-form-field>
                            @if (!employmentForm.controls.noticePeriodDays.value && employmentForm.controls.noticePeriodDays.touched) {
                              <mat-error role="alert"
                                >
                              Please enter your notice period</mat-error>
                            }
                            @if ((employmentForm.controls.noticePeriodDays.value && !employmentForm.controls.noticePeriodDays.valid) && !employmentForm.controls.noticePeriodDays.hasError('max')) {
                              <mat-error role="alert"
                                >
                              Please enter valid notice period</mat-error>
                            }
                            @if (employmentForm.controls.noticePeriodDays.hasError('max')) {
                              <mat-error role="alert">
                                Maximum of 120 days allowed for notice period
                              </mat-error>
                            }
                          </div>
                        }
                      </div>
                    }
                    @if (employmentForm.controls.isCurrentEmployer.value == 1) {
                      <div>
                        <div class="bottom-space">
                          <div id="canContactNow-radio-group" class="minor-list-space"><span><abbr title="required">*
                          </abbr>May we contact this employer?</span>
                        </div>
                        <mat-radio-group aria-label="Select an option" class="bottom-space"
                          aria-describedby="canContactNow-radio-group" (focusout)="canContactNowOnBlur(employmentForm)"
                          (focusin)="canContactNowOnFocus(employmentForm)" formControlName="canContactNow" required>
                          <mat-radio-button value="1" name="canContactNow"
                          class="minor-list-space radio-padding field-space">Yes</mat-radio-button>
                          <mat-radio-button value="0" name="canContactNow">No</mat-radio-button>
                          @if (submit.value && employmentForm.controls.canContactNow.hasError('required') || employmentForm.controls.canContactNow.hasError('requireError') ||  employmentForm.controls.checkCanContactNow.value) {
                            <mat-error
                              >
                            Please select May we contact this employer?</mat-error>
                          }
                        </mat-radio-group>
                      </div>
                    </div>
                  }
                  @if (employmentForm.controls.canContactNow.value === '0' && ousCountryMinusIndiaGBS && employmentForm.controls.isCurrentEmployer.value === '1') {
                    <div
                      >
                      <mat-form-field class="max-zoom field-space width-350" hideRequiredMarker>
                        <mat-label> <abbr title="required">* </abbr> Date we may contact</mat-label>
                        <input matInput [matDatepicker]="contactDatePicker" [min]="minDateContact" [max]="maxDateContact"
                          formControlName="contactDate" required maxlength="100">
                          <mat-datepicker-toggle matSuffix [for]="contactDatePicker"></mat-datepicker-toggle>
                          <mat-datepicker #contactDatePicker></mat-datepicker>
                          <mat-hint>Format mm/dd/yyyy</mat-hint>
                          @if (employmentForm.controls.contactDate.errors) {
                            <mat-error>
                            Please enter valid Date we can contact</mat-error>
                          }
                        </mat-form-field>
                      </div>
                    }
                    @if (jobCountry != 'IND') {
                      <div>
                        <div class="bottom-space">
                          <div id="hasAgency-radio-group" class="minor-list-space"><span><abbr title="required">*
                          </abbr>While
                          working for this company, were you employed directly with
                        this company or by an agency?</span>
                      </div>
                      <mat-radio-group class="bottom-space" aria-describedby="hasAgency-radio-group"
                        (focusout)="hasAgencyOnBlur(employmentForm)" (focusin)="hasAgencyOnFocus(employmentForm)"
                        aria-label="Select an option" formControlName="hasAgency" required>
                        <mat-radio-button value="0" name="hasAgency" class="minor-list-space radio-padding field-space">
                        Directly for this company</mat-radio-button>
                        <mat-radio-button value="1" name="hasAgency">Agency</mat-radio-button>
                        @if (submit.value && employmentForm.controls.hasAgency.hasError('required') || employmentForm.controls.checkhasAgency.value) {
                          <mat-error
                            >
                          Please enter Agency information</mat-error>
                        }
                      </mat-radio-group>
                    </div>
                    @if (employmentForm.controls.hasAgency.value == 1) {
                      <div>
                        <mat-form-field class="max-zoom field-space width-350" hideRequiredMarker>
                          <mat-label><abbr title="required">* </abbr>Agency name</mat-label>
                          <input matInput formControlName="agencyName" required maxlength="250">
                          <mat-error>Please enter Agency name</mat-error>
                        </mat-form-field>
                        <mat-form-field class="max-zoom field-space width-350" hideRequiredMarker>
                          <mat-label><abbr title="required">* </abbr>Agency contact information</mat-label>
                          <input matInput formControlName="agencyContactDetails" required maxlength="250">
                          <mat-error>Please enter Agency contact information </mat-error>
                        </mat-form-field>
                        <mat-form-field class="width-margin max-zoom field-space" hideRequiredMarker>
                          <mat-label><abbr title="required">* </abbr>Agency address</mat-label>
                          <input matInput formControlName="agencyAddress" required maxlength="250">
                          <mat-error>Please enter Agency address information</mat-error>
                        </mat-form-field>
                      </div>
                    }
                  </div>
                }
                @if (jobCountry == 'IND') {
                  <mat-form-field class="max-zoom field-space width-350" hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Nature of Employment</mat-label>
                    <mat-select formControlName="natureOfEmployment" required>
                      <mat-option>Select</mat-option>
                      @for (empType of employmentData.natureOfEmploymentLookup | keyvalue; track empType) {
                        <mat-option
                          [value]="empType.key">
                          {{empType.value}}
                        </mat-option>
                      }
                    </mat-select>
                    <mat-hint class="bofa--skiplink">
                      <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                      {{ dropDownScreenReaderNatureOfEmployment(employmentForm) }}
                    </mat-hint>
                    @if (employmentForm.controls.natureOfEmployment.hasError('required') ) {
                      <mat-error>Please select
                        Nature of Employment
                      </mat-error>
                    }
                  </mat-form-field>
                }
                <mat-form-field class="max-zoom field-space width-350" hideRequiredMarker>
                  <mat-label> <abbr title="required">* </abbr>Date employment began</mat-label>
                  <input matInput [matDatepicker]="dateEmpBeganPicker" [min]="minDate" [max]="maxDate"
                    formControlName="employmentStartDate" required maxlength="100">
                    <mat-datepicker-toggle matSuffix [for]="dateEmpBeganPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateEmpBeganPicker></mat-datepicker>
                    <mat-hint>Format mm/dd/yyyy</mat-hint>
                    @if (employmentForm.controls.employmentStartDate.errors) {
                      <mat-error>
                      Please enter valid Date employment began</mat-error>
                    }
                  </mat-form-field>
                  @if (employmentForm.controls.isCurrentEmployer.value == '0') {
                    <div>
                      <mat-form-field class="max-zoom field-space width-350" hideRequiredMarker>
                        <mat-label> <abbr title="required">* </abbr>Date employment ended</mat-label>
                        <input matInput [matDatepicker]="dateEmpEndedPicker" time="false" [min]="minDate" [max]="maxDate"
                          formControlName="employmentEndDate" required maxlength="100">
                          <mat-datepicker-toggle matSuffix [for]="dateEmpEndedPicker"></mat-datepicker-toggle>
                          <mat-datepicker #dateEmpEndedPicker></mat-datepicker>
                          <mat-hint>Format mm/dd/yyyy</mat-hint>
                          @if (employmentForm.controls.employmentEndDate.errors) {
                            <mat-error>
                            Please enter valid Date employment ended</mat-error>
                          }
                        </mat-form-field>
                      </div>
                    }
                    <p class="bofa--heading is-8 bold ">(2 of {{sections}}) General information</p>
                    <mat-form-field class="width-margin max-zoom field-space" hideRequiredMarker>
                      <mat-label><abbr title="required">* </abbr>Employer/Company name</mat-label>
                      <input matInput formControlName="employerName" required maxlength="200">
                      <mat-error>Please enter Employer/Company name</mat-error>
                    </mat-form-field>
                    @if (ousCountry) {
                      <div class="non-required">
                        <mat-form-field class="max-width width-310">
                          <mat-label>Employee ID</mat-label>
                          <input matInput formControlName="afEmployeeId" maxlength="100">
                        </mat-form-field>
                      </div>
                    }
                    <mat-form-field class="width-margin max-zoom field-space" hideRequiredMarker>
                      <mat-label><abbr title="required">* </abbr>Position/Title held</mat-label>
                      <input matInput formControlName="position" required maxlength="200">
                      <mat-error>Please enter Position/Title held</mat-error>
                    </mat-form-field>
                    <mat-form-field class="max-zoom field-space width-350" hideRequiredMarker>
                      <mat-label><abbr title="required">* </abbr>Type of employment</mat-label>
                      <mat-select formControlName="employmentType" required>
                        <mat-option>Select</mat-option>
                        @for (empType of employmentData.typeOfEmploymentLookup | keyvalue; track empType) {
                          <mat-option
                            [value]="empType.key">
                            {{empType.value}}
                          </mat-option>
                        }
                      </mat-select>
                      <mat-hint class="bofa--skiplink">
                        <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                        {{ dropDownScreenReaderTypeOfEmployment(employmentForm) }}
                      </mat-hint>
                      @if (employmentForm.controls.employmentType.hasError('required') ) {
                        <mat-error>Please select Type
                          of employment
                        </mat-error>
                      }
                    </mat-form-field>
                    <mat-form-field class="max-zoom field-space width-margin" hideRequiredMarker>
                      <mat-label><abbr title="required">* </abbr>Type of employer</mat-label>
                      <mat-select formControlName="businessTypeEmployer" required>
                        <mat-option>Select</mat-option>
                        @for (employerType of employmentData.typeOfEmployerLookup | keyvalue : valueAscOrderOtherLast; track employerType) {
                          <mat-option
                            [value]="employerType.key">
                            {{employerType.value}}
                          </mat-option>
                        }
                      </mat-select>
                      <mat-hint class="bofa--skiplink">
                        <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                        {{ dropDownScreenReaderBusinessTypeEmployer(employmentForm) }}
                      </mat-hint>
                      @if (employmentForm.controls.businessTypeEmployer.hasError('required') ) {
                        <mat-error>Please select
                        Type of employer</mat-error>
                      }
                    </mat-form-field>
                    @if (!ousCountryMinusIndiaGBS) {
                      <div>
                        <mat-form-field class="max-zoom field-space width-margin" hideRequiredMarker>
                          <mat-label>@if (jobCountry != 'IND') {
                            <abbr title="required">* </abbr>
                            }Brief description of job
                          responsibilities</mat-label>
                          <textarea matInput formControlName="workDescription" maxlength="1000"></textarea>
                          <mat-hint align="end">
                            {{(employmentForm.controls.workDescription.value)?employmentForm.controls.workDescription.value.length:0}}
                          / 1000</mat-hint>
                          <mat-error>Please enter Responsibilities</mat-error>
                        </mat-form-field>
                      </div>
                    }
                    @if ((employmentForm.controls.isCurrentEmployer.value == 0 || ousCountryMinusIndiaGBS)) {
                      <mat-form-field
                        class="max-zoom field-space width-350" hideRequiredMarker>
                        <mat-label><abbr title="required">* </abbr>Reason for Leaving</mat-label>
                        <mat-select formControlName="reason" required
                          (selectionChange)="onReasonChange($event ,employmentForm.controls.reasonCodeForLeavingLookup )">
                          <mat-option>Select</mat-option>
                          @for (reason of employmentData.reasonForLeavingLookup | keyvalue; track reason) {
                            <mat-option
                              [value]="reason.key">
                              {{reason.value}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (employmentForm.controls.reason.hasError('required') ) {
                          <mat-error>Please select Reason for
                            Leaving
                          </mat-error>
                        }
                        <mat-hint class="bofa--skiplink">
                          <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                          {{ dropDownScreenReaderReasonForLeaving(employmentForm) }}
                        </mat-hint>
                      </mat-form-field>
                    }
                    @if (employmentForm.controls.isCurrentEmployer.value == 0  || ousCountryMinusIndiaGBS) {
                      <mat-form-field
                        class="max-zoom field-space width-350" hideRequiredMarker>
                        <mat-label>@if (!isCountryIndiaGBS) {
                          <abbr title="required">* </abbr>
                          }Reason Code for Leaving
                        </mat-label>
                        <mat-select formControlName="reasonCode" [required]="!isCountryIndiaGBS">
                          <mat-option>Select</mat-option>
                          @for (reasonCode of employmentData.reasonCodeForLeavingLookup | keyvalue : valueAscOrderOtherLast; track reasonCode) {
                            <mat-option
                              [value]="reasonCode.key">
                              {{reasonCode.value}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (employmentForm.controls.reasonCode.hasError('required') ) {
                          <mat-error>Please enter Reason Code
                            for Leaving.
                          </mat-error>
                        }
                        <mat-hint class="bofa--skiplink">
                          <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                          {{ dropDownScreenReaderReasonCode(employmentForm) }}
                        </mat-hint>
                      </mat-form-field>
                    }
                    @if (employmentForm.controls.isCurrentEmployer.value == 0 || ousCountryMinusIndiaGBS) {
                      <label
                        class="label-color" for="addnlDetailsForRFLId">@if (!isCountryIndiaGBS) {
                        <abbr
                        title="required">* </abbr>
                        }Additional Details regarding
                        Reason for Leaving
                      </label>
                    }
                    @if (employmentForm.controls.isCurrentEmployer.value == 0 || ousCountryMinusIndiaGBS) {
                      <mat-form-field
                        class="max-zoom field-space width-margin" hideRequiredMarker>
                        <mat-label class="bofa--skiplink"><abbr title="required">* </abbr>Additional Details regarding Reason for Leaving</mat-label>
                        <textarea matInput id="addnlDetailsForRFLId" formControlName="addnlDetailsForRFL"
                        [required]="!isCountryIndiaGBS" maxlength="1000"></textarea>
                        <mat-hint align="end">
                          {{(employmentForm.controls.addnlDetailsForRFL.value)?employmentForm.controls.addnlDetailsForRFL.value.length:0}}
                        / 1000</mat-hint>
                        <mat-error>Please enter Additional Details</mat-error>
                      </mat-form-field>
                    }
                    @if (jobCountry == 'IND') {
                      <div class="non-required">
                        <mat-form-field class="max-width width-310">
                          <mat-label>Current Remuneration (Per Annum) (optional)</mat-label>
                          <input matInput formControlName="currentRemunaration" maxlength="200">
                        </mat-form-field>
                      </div>
                    }
                    @if (jobCountry == 'IND') {
                      <div>
                        <mat-radio-group class="bottom-space minor-radio-padding" formControlName="fixedOrVariable">
                          <mat-radio-button class="minor-list-space radio-padding field-space" matInput [value]=0
                          name="fixedOrVariable">Fixed</mat-radio-button>
                          <mat-radio-button class="minor-radio-padding" matInput [value]=1 name="fixedOrVariable">Variable
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                    }
                    <p class="bofa--heading is-8 bold ">(3 of {{sections}}) Employer information</p>
                    <mat-form-field class="max-zoom field-space width-margin" hideRequiredMarker>
                      <mat-label><abbr title="required">* </abbr>Employer street address</mat-label>
                      <input matInput formControlName="streetAddressOne" required maxlength="100">
                      <mat-error>Please enter Employer street address</mat-error>
                    </mat-form-field>
                    <div class="non-required bottom-space">
                      <mat-form-field class="max-width width-350">
                        <mat-label>More street address (if applicable)</mat-label>
                        <input matInput formControlName="streetAddressTwo" maxlength="150">
                      </mat-form-field>
                    </div>
                    <div class="non-required bottom-space">
                      <mat-form-field class="max-width width-350">
                        <mat-label>More street address (if applicable)</mat-label>
                        <input matInput formControlName="streetAddressThree" maxlength="255">
                      </mat-form-field>
                    </div>
                    <mat-form-field class="max-zoom field-space width-margin" hideRequiredMarker>
                      <mat-label><abbr title="required">* </abbr>Employer Zip / Postal code</mat-label>
                      <input matInput formControlName="zipCode" required maxlength="13">
                      <mat-error>Please enter Employer Zip / Postal code</mat-error>
                    </mat-form-field>
                    <mat-form-field class="max-zoom field-space width-margin" hideRequiredMarker>
                      <mat-label><abbr title="required">* </abbr>Employer Town/City/Province</mat-label>
                      <input matInput formControlName="city" required maxlength="100">
                      <mat-error>Please enter Employer Town/City/Province</mat-error>
                    </mat-form-field>
                    <mat-form-field class="max-zoom field-space width-350" hideRequiredMarker>
                      <mat-label><abbr title="required">* </abbr>Employer Country</mat-label>
                      <mat-select formControlName="country" required>
                        <mat-option>Select</mat-option>
                        @for (country of employmentData.countryLookup | keyvalue : valueAscOrder; track country) {
                          <mat-option
                            [value]="country.key">
                            {{country.value}}
                          </mat-option>
                        }
                      </mat-select>
                      <mat-hint class="bofa--skiplink">
                        <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                        {{ dropDownScreenReaderCountry(employmentForm) }}
                      </mat-hint>
                      @if (employmentForm.controls.country.hasError('required') ) {
                        <mat-error>Please select Employer
                          Country
                        </mat-error>
                      }
                    </mat-form-field>
                    @if (employmentForm.controls.country.value == 186) {
                      <div>
                        <mat-form-field class="max-zoom field-space width-margin-25" hideRequiredMarker>
                          <mat-label><abbr title="required">* </abbr>Employer State/Region</mat-label>
                          <mat-select formControlName="usState" required>
                            <mat-option>Select</mat-option>
                            @for (usState of employmentData.usStateLookup | keyvalue : valueAscOrder; track usState) {
                              <mat-option
                                [value]="usState.key">
                                {{usState.value}}
                              </mat-option>
                            }
                          </mat-select>
                          <mat-hint class="bofa--skiplink">
                            <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                            {{ dropDownScreenReaderState(employmentForm) }}
                          </mat-hint>
                          @if (employmentForm.controls.usState.hasError('required') || employmentForm.controls.usState.hasError('requireError')) {
                            <mat-error
                              >
                            Please enter Employer State/Region </mat-error>
                          }
                        </mat-form-field>
                      </div>
                    }
                    @if (employmentForm.controls.country.value != 186) {
                      <div>
                        <mat-form-field class="max-zoom field-space width-margin-25" hideRequiredMarker>
                          <mat-label><abbr title="required">* </abbr>Employer State/Region</mat-label>
                          <input matInput formControlName="state" required maxlength="100">
                          <mat-error>Please enter Employer State/Region</mat-error>
                        </mat-form-field>
                      </div>
                    }
                    @if (jobCountry == 'IND') {
                      <mat-form-field class="max-zoom field-space width-margin-1"
                        hideRequiredMarker>
                        <mat-label><abbr title="required">* </abbr>Employer phone number</mat-label>
                        <input matInput formControlName="businessPhoneNumber" required maxlength="30" minlength="9">
                        @if (employmentForm.controls.businessPhoneNumber.errors) {
                          <mat-error>Please enter a valid Phone
                            number
                          </mat-error>
                        }
                      </mat-form-field>
                    }
                    @if (jobCountry != 'IND') {
                      <div class="non-required">
                        <mat-form-field class="max-width width-310">
                          <mat-label>Employer phone number (optional)</mat-label>
                          <input matInput formControlName="businessPhoneNumber" maxlength="30">
                          <mat-error>Please enter a valid Phone number</mat-error>
                        </mat-form-field>
                      </div>
                    }
                    <div class="non-required">
                      <mat-form-field class="max-width width-310">
                        <mat-label>Employer website (optional)</mat-label>
                        <input matInput formControlName="employerWebsite" maxlength="100">
                      </mat-form-field>
                    </div>
                    @if (ousCountryMinusIndiaGBS) {
                      <div>
                        <p class="bofa--heading is-8 bold ">(4 of {{sections}}) Reference Contact Information</p>
                      </div>
                    }
                    @if (!ousCountryMinusIndiaGBS) {
                      <div>
                        <p class="bofa--heading is-8 bold ">(4 of {{sections}}) Manager Information</p>
                      </div>
                    }
                    <mat-form-field class="max-zoom field-space width-margin-25" hideRequiredMarker>
                      @if (ousCountryMinusIndiaGBS) {
                        <mat-label><abbr title="required">* </abbr>Reference contact's full
                      name</mat-label>
                    }
                    @if (!ousCountryMinusIndiaGBS) {
                      <mat-label><abbr title="required">* </abbr>Manager's full
                    name</mat-label>
                  }
                  <input matInput formControlName="managerName" required maxlength="200">
                  @if (ousCountryMinusIndiaGBS) {
                    <mat-error>Please enter the reference contact's full
                    name</mat-error>
                  }
                  @if (!ousCountryMinusIndiaGBS) {
                    <mat-error>Please enter the manager's full name</mat-error>
                  }
                </mat-form-field>
                @if (ousCountryMinusIndiaGBS) {
                  <div class=”non-required”>
                    <label for="managerPhoneNumberId" id="managerPhoneNumberDesc">Reference contact's phone number
                      including country code (optional)
                    </label>
                    <mat-form-field class="max-zoom field-space width-margin-1"
                      aria-describedby="managerPhoneNumberDesc">
                      <input matInput id="managerPhoneNumberId" formControlName="managerPhoneNumber" maxlength="25">
                    </mat-form-field>
                  </div>
                }
                @if (!ousCountryMinusIndiaGBS) {
                  <mat-form-field class="max-zoom field-space width-margin-1"
                    hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Manager's phone number</mat-label>
                    <input matInput formControlName="managerPhoneNumber" required maxlength="30" minlength="9">
                    @if (employmentForm.controls.managerPhoneNumber.errors) {
                      <mat-error>Please
                        enter your Manager's phone number including the area code (minimum of 10 characters required)
                      </mat-error>
                    }
                  </mat-form-field>
                }
                @if (ousCountryMinusIndiaGBS) {
                  <div>
                    <mat-form-field class="max-width width-310" hideRequiredMarker>
                      <mat-label><abbr title="required">* </abbr>Reference contact's email address</mat-label>
                      <input matInput formControlName="managerEmailAddress" required maxlength="200">
                    </mat-form-field>
                    @if (employmentForm.controls.managerEmailAddress.invalid && (employmentForm.controls.managerEmailAddress.touched || employmentForm.controls.managerEmailAddress.dirty)) {
                      <mat-error
                        >
                        Please enter your reference contact's email
                      </mat-error>
                    }
                  </div>
                }
                @if (!ousCountryMinusIndiaGBS) {
                  <div class="non-required">
                    <mat-form-field class="max-width width-310">
                      <mat-label>Manager's email address (optional)</mat-label>
                      <input matInput formControlName="managerEmailAddress" maxlength="200">
                    </mat-form-field>
                  </div>
                }
                @if (jobCountry == 'IND') {
                  <div>
                    <div class="margin-top-1">
                      <div class="bottom-space">
                        <div id="managerStillEmployed-radio-group" class="minor-list-space"><span><abbr
                        title="required">* </abbr>Is Manager Still Part of the Company? </span>
                      </div>
                      <mat-radio-group aria-describedby="managerStillEmployed-radio-group"
                        aria-label="Select an option" formControlName="managerStillEmployed">
                        <mat-radio-button value="1" name="managerStillEmployed"
                        class="minor-list-space radio-padding field-space">Yes</mat-radio-button>
                        <mat-radio-button value="0" name="managerStillEmployed">No
                        </mat-radio-button>
                        @if (submit.value && employmentForm.controls.managerStillEmployed.hasError('required') ) {
                          <mat-error
                            >
                            Please enter Is Manager Still Part of the Company?
                          </mat-error>
                        }
                      </mat-radio-group>
                    </div>
                  </div>
                  <mat-form-field class="max-zoom field-space width-margin-1" hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Manager's Designation </mat-label>
                    <input matInput formControlName="managerDesignation" required>
                    @if (employmentForm.controls.managerDesignation.errors) {
                      <mat-error>Please
                        enter your Manager's Designation
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              }
              @if (jobCountry == 'IND') {
                <p class="bofa--heading is-8 bold">(5 of {{sections}}) Document
                Information</p>
              }
              @if (jobCountry == 'IND') {
                <div class="bottom-space">
                  <div id="required-documents" class="bottom-space">
                    @if (employmentForm.controls.isCurrentEmployer.value == 1) {
                      <span> Accepted Documentation for
                      Current Employment</span>
                    }
                    @if (employmentForm.controls.isCurrentEmployer.value == 0) {
                      <span> Accepted Documentation for
                      Previous Employment</span>
                    }
                  </div>
                  <!-- current employer -->
                  <div class="bottom-space" [hidden]="employmentForm.controls.isCurrentEmployer.value == 0" hideRequiredMarker>
                    <div class="max-zoom field-space width_350">
                      <p id="currDateOfJoiningProofLabel" class="file-attachment-label"><abbr title="required">*</abbr> Date of Joining proof </p>
                      <input matInput formControlName="currentDojProofId" hidden type="text" aria-required=true  aria-label="CurrentDOJProof" />
                      <button type="button" class="float_right bofa--button secondary"
                        [disabled]="!isEmpty(i,'currentDojProofId')"
                      (click)="openFileDialog(true, 'currentDojProofId',1)">Attach</button>
                      @if (!isEmpty(i,'currentDojProofId')) {
                        <span><strong>{{ employmentForm.controls.currentDojProofIdName?.value  }}</strong></span>
                      }
                      @if (!isEmpty(i,'currentDojProofId')) {
                        <p class="file-attached-info">
                          <span class="file-actions">
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Download Employer Date Of Joining Proof"
                            (click)="getAttachment('currentDojProofId')">Download</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Update Employer Date Of Joining Prood"
                            (click)="updateAttachment('currentDojProofId')">Update</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Delete Employer Date Of Joining Proof"
                            (click)="deleteAttachment('currentDojProofId',1)">Delete</button>
                          </span>
                        </p>
                      }
                    </div>
                    @if ((submit.value && !employmentForm.controls.currentDojProofId.value) && !employmentForm.controls.currentDojProofId.value) {
                      <mat-error
                        >
                        Please attach a file
                      </mat-error>
                    }
                  </div>
                  <div class="bottom-space" [hidden]="employmentForm.controls.isCurrentEmployer.value == 0" hideRequiredMarker>
                    <div class="max-zoom field-space width_350">
                      <p id="currDesiginationProofLabel" class="file-attachment-label"><abbr title="required">*</abbr> Designation proof </p>
                      <input matInput formControlName="currentDesignationProofId" hidden type="text" aria-required=true  aria-label="CurrentDesignationProof" />
                      <button type="button" class="float_right bofa--button secondary"
                        [disabled]="!isEmpty(i,'currentDesignationProofId')"
                      (click)="openFileDialog(true ,'currentDesignationProofId',i)">Attach</button>
                      @if (!isEmpty(i,'currentDesignationProofId')) {
                        <span><strong>{{ employmentForm.controls.currentDesignationProofIdName?.value  }}</strong></span>
                      }
                      @if (!isEmpty(i,'currentDesignationProofId')) {
                        <p class="file-attached-info">
                          <span class="file-actions">
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Download Designation Proof"
                            (click)="getAttachment('currentDesignationProofId')">Download</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Update Designation Proof"
                            (click)="updateAttachment('currentDesignationProofId')">Update</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Delete Designation Proof"
                            (click)="deleteAttachment('currentDesignationProofId',2)">Delete</button>
                          </span>
                        </p>
                      }
                    </div>
                    @if ((submit.value && !employmentForm.controls.currentDesignationProofId.value) && !employmentForm.controls.currentDesignationProofId.value) {
                      <mat-error
                        >
                        Please attach a file
                      </mat-error>
                    }
                  </div>
                  <div class="bottom-space" [hidden]="employmentForm.controls.isCurrentEmployer.value == 0">
                    <div class="max-zoom field-space width_350">
                      <p id="currOfferLetterLabel" class="file-attachment-label"> Current Offer Letter </p>
                      <input matInput formControlName="currentOfferLetterId" hidden type="text" aria-required=true  aria-label="CurrentOfferLetter" />
                      <button type="button" class="float_right bofa--button secondary"
                        [disabled]="!isEmpty(i,'currentOfferLetterId')"
                      (click)="openFileDialog(true ,'currentOfferLetterId',i)">Attach</button>
                      @if (!isEmpty(i,'currentOfferLetterId')) {
                        <span><strong>{{ employmentForm.controls.currentOfferLetterIdName?.value }}</strong></span>
                      }
                      @if (!isEmpty(i,'currentOfferLetterId')) {
                        <p class="file-attached-info">
                          <span class="file-actions">
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Download Offer Letter"
                            (click)="getAttachment('currentOfferLetterId')">Download</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Update Offer Letter"
                            (click)="updateAttachment('currentOfferLetterId')">Update</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Delete Offer Letter"
                            (click)="deleteAttachment('currentOfferLetterId')">Delete</button>
                          </span>
                        </p>
                      }
                    </div>
                  </div>
                  <div class="bottom-space" [hidden]="employmentForm.controls.isCurrentEmployer.value == 0">
                    <div class="max-zoom field-space width_350">
                      <p id="currCompensationLetterLabel" class="file-attachment-label"> Compensation Letter </p>
                      <input matInput formControlName="currentCompensationLetterId" hidden type="text" aria-required=true  aria-label="CurrentCompensationLetter" />
                      <button type="button" class="float_right bofa--button secondary"
                        [disabled]="!isEmpty(i,'currentCompensationLetterId')"
                      (click)="openFileDialog(true ,'currentCompensationLetterId',i)">Attach</button>
                      @if (!isEmpty(i,'currentCompensationLetterId')) {
                        <span><strong>{{ employmentForm.controls.currentCompensationLetterIdName?.value }}</strong></span>
                      }
                      @if (!isEmpty(i,'currentCompensationLetterId')) {
                        <p class="file-attached-info">
                          <span class="file-actions">
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Download Compensation Letter"
                            (click)="getAttachment('currentCompensationLetterId')">Download</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Update Compensation Letter"
                            (click)="updateAttachment('currentCompensationLetterId')">Update</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Delete Compensation Letter"
                            (click)="deleteAttachment('currentCompensationLetterId')">Delete</button>
                          </span>
                        </p>
                      }
                    </div>
                  </div>
                  <div class="bottom-space" [hidden]="employmentForm.controls.isCurrentEmployer.value == 0">
                    <div class="max-zoom field-space width_350">
                      <p id="currLatestSalarySlipsLabel" class="file-attachment-label"> Three latest salary slips </p>
                      <input matInput formControlName="currentLatestThreePaySlipId" hidden type="text" aria-required=true  aria-label="CurrentLatestThreePayslips" />
                      <button type="button" class="float_right bofa--button secondary"
                        [disabled]="!isEmpty(i,'currentLatestThreePaySlipId')"
                      (click)="openFileDialog(true ,'currentLatestThreePaySlipId',i)">Attach</button>
                      @if (!isEmpty(i,'currentLatestThreePaySlipId')) {
                        <span><strong>{{ employmentForm.controls.currentLatestThreePaySlipIdName?.value }}</strong></span>
                      }
                      @if (!isEmpty(i,'currentLatestThreePaySlipId')) {
                        <p class="file-attached-info">
                          <span class="file-actions">
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Download Three Latest Salary Slips"
                            (click)="getAttachment('currentLatestThreePaySlipId')">Download</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Update Three Latest Salary Slips"
                            (click)="updateAttachment('currentLatestThreePaySlipId')">Update</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Delete Three Latest Salary Slips"
                            (click)="deleteAttachment('currentLatestThreePaySlipId')">Delete</button>
                          </span>
                        </p>
                      }
                    </div>
                  </div>
                  <!-- Previous Employer -->
                  <div class="bottom-space" [hidden]="employmentForm.controls.isCurrentEmployer.value == 1"
                    hideRequiredMarker>
                    <div class="max-zoom field-space width_350">
                      <p id="prevDateOfJoiningProofLabel" class="file-attachment-label"><abbr title="required">*</abbr> Date of Joining proof </p>
                      <input matInput formControlName="previousDojProofId" hidden type="text" aria-required=true  aria-label="PreviousDOJProof" />
                      <button type="button" class="float_right bofa--button secondary"
                        [disabled]="!isEmpty(i,'previousDojProofId')"
                      (click)="openFileDialog(true ,'previousDojProofId',i)">Attach</button>
                      @if (!isEmpty(i,'previousDojProofId')) {
                        <span><strong>{{ employmentForm.controls.previousDojProofIdName?.value }}</strong></span>
                      }
                      @if (!isEmpty(i,'previousDojProofId')) {
                        <p class="file-attached-info">
                          <span class="file-actions">
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Download Date Of Joining Proof"
                            (click)="getAttachment('previousDojProofId')">Download</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Update Date Of Joining Proof"
                            (click)="updateAttachment('previousDojProofId')">Update</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Delete Date Of Joining Proof"
                            (click)="deleteAttachment('previousDojProofId')">Delete</button>
                          </span>
                        </p>
                      }
                    </div>
                    @if ((submit.value && !employmentForm.controls.previousDojProofId.value) && !employmentForm.controls.previousDojProofId.value) {
                      <mat-error
                        >
                        Please attach a file
                      </mat-error>
                    }
                  </div>
                  <div class="bottom-space" [hidden]="employmentForm.controls.isCurrentEmployer.value == 1"
                    hideRequiredMarker>
                    <div class="max-zoom field-space width_350">
                      <p id="prevDesiginationProofLabel" class="file-attachment-label"><abbr title="required">*</abbr> Designation Proof </p>
                      <input matInput formControlName="previousDesignationProofId" hidden type="text" aria-required=true  aria-label="PreviousDesignationProof" />
                      <button type="button" class="float_right bofa--button secondary"
                        [disabled]="!isEmpty(i,'previousDesignationProofId')"
                      (click)="openFileDialog(true ,'previousDesignationProofId',i)">Attach</button>
                      @if (!isEmpty(i,'previousDesignationProofId')) {
                        <span><strong>{{ employmentForm.controls.previousDesignationProofIdName?.value }}</strong></span>
                      }
                      @if (!isEmpty(i,'previousDesignationProofId')) {
                        <p class="file-attached-info">
                          <span class="file-actions">
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Download Designation Proof"
                            (click)="getAttachment('previousDesignationProofId')">Download</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Update Designation Proof"
                            (click)="updateAttachment('previousDesignationProofId')">Update</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Delete Designation Proof"
                            (click)="deleteAttachment('previousDesignationProofId')">Delete</button>
                          </span>
                        </p>
                      }
                    </div>
                    @if ((submit.value && !employmentForm.controls.previousDesignationProofId.value) && !employmentForm.controls.previousDesignationProofId.value) {
                      <mat-error
                        >
                        Please attach a file
                      </mat-error>
                    }
                  </div>
                  <div class="bottom-space" [hidden]="employmentForm.controls.isCurrentEmployer.value == 1"
                    hideRequiredMarker>
                    <div class="max-zoom field-space width_350">
                      <p id="lastDayWorkingLabel" class="file-attachment-label"><abbr title="required">*</abbr> Last Working Day Proof(Relieving Letter/FnF)</p>
                      <input matInput formControlName="lwdProofId" hidden type="text" aria-required=true  aria-label="PreviousDesignationProof" />
                      <button type="button" class="float_right bofa--button secondary"
                        [disabled]="!isEmpty(i,'lwdProofId')"
                      (click)="openFileDialog(true ,'lwdProofId',i)">Attach</button>
                      @if (!isEmpty(i,'lwdProofId')) {
                        <span><strong>{{ employmentForm.controls.lwdProofIdName?.value }}</strong></span>
                      }
                      @if (!isEmpty(i,'lwdProofId')) {
                        <p class="file-attached-info">
                          <span class="file-actions">
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Download Last Working Day Proof"
                            (click)="getAttachment('lwdProofId')">Download</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Update Last Working Day Proof"
                            (click)="updateAttachment('lwdProofId')">Update</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Delete Last Working Day Proof"
                            (click)="deleteAttachment('lwdProofId')">Delete</button>
                          </span>
                        </p>
                      }
                    </div>
                    @if ((submit.value && !employmentForm.controls.lwdProofId.value) && !employmentForm.controls.lwdProofId.value) {
                      <mat-error
                        >
                        Please attach a file
                      </mat-error>
                    }
                  </div>
                  <div class="bottom-space" [hidden]="employmentForm.controls.isCurrentEmployer.value == 1">
                    <div class="max-zoom field-space width_350">
                      <p id="prevOfferLetterLabel" class="file-attachment-label"> Offer Letter </p>
                      <input matInput formControlName="previousOfferLetterId" hidden type="text" aria-required=true  aria-label="PreviousOfferLetter" />
                      <button type="button" class="float_right bofa--button secondary"
                        [disabled]="!isEmpty(i,'previousOfferLetterId')"
                      (click)="openFileDialog(true ,'previousOfferLetterId',i)">Attach</button>
                      @if (!isEmpty(i,'previousOfferLetterId')) {
                        <span><strong>{{ employmentForm.controls.previousOfferLetterIdName?.value }}</strong></span>
                      }
                      @if (!isEmpty(i,'previousOfferLetterId')) {
                        <p class="file-attached-info">
                          <span class="file-actions">
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Download Offer Letter"
                            (click)="getAttachment('previousOfferLetterId')">Download</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Update Offer Letter"
                            (click)="updateAttachment('previousOfferLetterId')">Update</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Delete Offer Letter"
                            (click)="deleteAttachment('previousOfferLetterId')">Delete</button>
                          </span>
                        </p>
                      }
                    </div>
                  </div>
                  <div class="bottom-space" [hidden]="employmentForm.controls.isCurrentEmployer.value == 1">
                    <div class="max-zoom field-space width_350">
                      <p id="prevCompensationLetterLabel" class="file-attachment-label"> Compensation Letter </p>
                      <input matInput formControlName="previousCompensationLetterId" hidden type="text" aria-required=true  aria-label="CurrentDesignationProof" />
                      <button type="button" class="float_right bofa--button secondary"
                        [disabled]="!isEmpty(i,'previousCompensationLetterId')"
                      (click)="openFileDialog(true ,'previousCompensationLetterId',i)">Attach</button>
                      @if (!isEmpty(i,'previousCompensationLetterId')) {
                        <span><strong>{{ employmentForm.controls.previousCompensationLetterIdName?.value }}</strong></span>
                      }
                      @if (!isEmpty(i,'previousCompensationLetterId')) {
                        <p class="file-attached-info">
                          <span class="file-actions">
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Download Compensation Letter"
                            (click)="getAttachment('previousCompensationLetterId')">Download</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Update Compensation Letter"
                            (click)="updateAttachment('previousCompensationLetterId')">Update</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Delete Compensation Letter"
                            (click)="deleteAttachment('previousCompensationLetterId')">Delete</button>
                          </span>
                        </p>
                      }
                    </div>
                  </div>
                  <div class="bottom-space" [hidden]="employmentForm.controls.isCurrentEmployer.value == 1">
                    <div class="max-zoom field-space width_350">
                      <p id="prevLatestSalarySlipsLabel" class="file-attachment-label"> Three latest salary slips </p>
                      <input matInput formControlName="previousLastThreeMonthPaySlipId" hidden type="text" aria-required=true   aria-label="CurrentDesignationProof" />
                      <button type="button" class="float_right bofa--button secondary"
                        [disabled]="!isEmpty(i,'previousLastThreeMonthPaySlipId')"
                      (click)="openFileDialog(true ,'previousLastThreeMonthPaySlipId',i)">Attach</button>
                      @if (!isEmpty(i,'previousLastThreeMonthPaySlipId')) {
                        <span><strong>{{ employmentForm.controls.previousLastThreeMonthPaySlipIdName?.value }}</strong></span>
                      }
                      @if (!isEmpty(i,'previousLastThreeMonthPaySlipId')) {
                        <p class="file-attached-info">
                          <span class="file-actions">
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Download Three Latest Salary Slips"
                            (click)="getAttachment('previousLastThreeMonthPaySlipId')">Download</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Update Three Latest Salary Slips"
                            (click)="updateAttachment('previousLastThreeMonthPaySlipId')">Update</button>
                            <span class="file-action-divider" aria-hidden="true">|</span>
                            <button type="button" class="bofa--button secondary outlined file-action-button"
                              aria-label="Delete Three Latest Salary Slips"
                            (click)="deleteAttachment('previousLastThreeMonthPaySlipId')">Delete</button>
                          </span>
                        </p>
                      }
                    </div>
                  </div>
                </div>
              }
              <div class="is-taller remove-button-align">
                <button type="button" class="bofa--button primary outlined"
                (click)="deleteEmploymentClick(i)">Remove this employer</button>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        }
      </div>
    </div>
  }
  <div #target2 class="is-taller">
    <div class="level">
      <div class="level-item">
        @if (hasEmploymentBreakHistory()) {
          <h2 class="bofa--heading is-6">Enter your employment break
          history</h2>
        }
      </div>
    </div>
  </div>
  @for (employmentForm of employmentBreakList.controls; track employmentForm; let i = $index) {
    <div [formGroup]="employmentForm">
      @if (stepEmploymentBreak === i) {
        <mat-accordion multi="true">
          <mat-expansion-panel [class.border]="borderEmpBreak" [expanded]="stepEmploymentBreak === i"
            [hideToggle]="true" (opened)="setEmploymentBreakStep(i)"
            class="af-mat-card mat-elevation-z panel-width">
            <mat-expansion-panel-header class="mat-expansion outlined background-color-rgba">
              <mat-panel-title>
                Employment Break {{i + 1}}
              </mat-panel-title>
              <mat-panel-description>
                <div class="float-cursor-margin">
                  <button type="button" class="icon-button" (click)="deleteEmploymentBreakClick(i, $event)" (keyup.enter)="deleteEmploymentBreakClick(i, $event)">
                    <svg class="height-width" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-label="remove employment break">
                      <g data-name="24 x 24 BOX">
                        <rect fill="none" width="24" height="24"/>
                      </g>
                      <g data-name="ICON OUTLINE">
                      <polygon fill="#e31837" points="21 3.707 20.293 3 12 11.293 3.707 3 3 3.707 11.293 12 3 20.293 3.707 21 12 12.707 20.293 21 21 20.293 12.707 12 21 3.707"/></g>
                    </svg>
                    <span class="bofa--skiplink">icon</span>
                  </button>
                </div>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <!-- set focus when pressing Add button -->
            <div tabindex="-1" #addEmploymentBreakElement class="bofa--skiplink">
            </div>
            <div class="margin-top-1">
              <div class="bottom-space">
                <div id="isCurrentEmploymentStatus-radio-group" class="minor-list-space"><span><abbr
                title="required">* </abbr>Is this your current employment
              status?</span>
            </div>
            <mat-radio-group aria-describedby="isCurrentEmploymentStatus-radio-group"
              aria-label="Select an option" (focusout)="isCurrentEmploymentStatusOnBlur(employmentForm)"
              (focusin)="isCurrentEmploymentStatusOnFocus(employmentForm)"
              formControlName="isCurrentEmploymentStatus">
              <mat-radio-button value="1" name="isCurrentEmploymentStatus"
              class="minor-list-space radio-padding field-space">Yes</mat-radio-button>
              <mat-radio-button value="0" name="isCurrentEmploymentStatus">No
              </mat-radio-button>
              @if (submit.value && employmentForm.controls.isCurrentEmploymentStatus.hasError('required') ||  employmentForm.controls.checkisCurrentEmploymentStatus.value) {
                <mat-error
                  >
                  Please enter Is this your current employment status?
                </mat-error>
              }
            </mat-radio-group>
          </div>
        </div>
        <mat-form-field class="max-zoom field-space width-350" hideRequiredMarker>
          <mat-label> <abbr title="required">* </abbr>Date break in employment began</mat-label>
          <input matInput [matDatepicker]="dateBreakBeganPicker" [min]="minDate" [max]="maxDate"
            formControlName="employmentBreakFromDate" required maxlength="100">
            <mat-datepicker-toggle matSuffix [for]="dateBreakBeganPicker"></mat-datepicker-toggle>
            <mat-datepicker #dateBreakBeganPicker></mat-datepicker>
            <mat-hint>Format mm/dd/yyyy</mat-hint>
            @if (employmentForm.controls.employmentBreakFromDate.errors) {
              <mat-error>
              Please enter valid Date break began</mat-error>
            }
          </mat-form-field>
          @if (employmentForm.controls.isCurrentEmploymentStatus.value == '0') {
            <div>
              <mat-form-field class="max-zoom field-space width-350" hideRequiredMarker>
                <mat-label> <abbr title="required">* </abbr>Date break in employment ended</mat-label>
                <input matInput [matDatepicker]="dateBreakEndedPicker" [min]="minDate" [max]="maxDate"
                  formControlName="employmentBreakToDate" required maxlength="100">
                  <mat-datepicker-toggle matSuffix [for]="dateBreakEndedPicker"></mat-datepicker-toggle>
                  <mat-datepicker #dateBreakEndedPicker></mat-datepicker>
                  <mat-hint>Format mm/dd/yyyy</mat-hint>
                  @if (employmentForm.controls.employmentBreakFromDate.errors) {
                    <mat-error>
                    Please enter valid Date break ended</mat-error>
                  }
                </mat-form-field>
              </div>
            }
            <mat-form-field class="max-zoom field-space width-margin-25" hideRequiredMarker>
              <mat-label><abbr title="required">* </abbr>Reason for break in employment</mat-label>
              <mat-select formControlName="employmentBreakReason" required>
                <mat-option>Select</mat-option>
                @for (empBreakLookup of employmentData.reasonEmploymentBreakLookup | keyvalue; track empBreakLookup) {
                  <mat-option
                    [value]="empBreakLookup.key">
                    {{empBreakLookup.value}}
                  </mat-option>
                }
              </mat-select>
              <mat-hint class="bofa--skiplink">
                <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                {{ dropDownScreenReaderemploymentBreakReason(employmentForm) }}
              </mat-hint>
              @if (employmentForm.controls.employmentBreakReason.hasError('required') ) {
                <mat-error>Please select
                Reason for break in employment</mat-error>
              }
            </mat-form-field>
            <mat-form-field class="max-zoom field-space width-350" hideRequiredMarker>
              <mat-label id="emp-break-comments-label"><abbr title="required">* </abbr>Comments</mat-label>
              <textarea matInput formControlName="employmentBreakComment" required maxlength="1000"
              aria-labelledby="emp-break-comments-label"></textarea>
              <mat-hint align="end">
                {{(employmentForm.controls.employmentBreakComment.value)?employmentForm.controls.employmentBreakComment.value.length:0}}
              / 1000</mat-hint>
              <mat-error>Please enter Comments</mat-error>
            </mat-form-field>
          </mat-expansion-panel>
        </mat-accordion>
      }
    </div>
  }
</div>
<!-- Horizontal view -->
@if (!employmentChange) {
  <div class="fx-flex-60">
    <div [class.sticky]="sticky" class="max-width-535" [style.overflow]="'auto'" #stickyDiv>
      <div class="is-taller">
        <div class="level">
          <div class="width-padding-left" id="review-employment-horizontal">
            @if (hasEmploymentHistory()) {
              <span class="bofa--heading is-6">Review your employment history</span>
            }
          </div>
          <div class="width-padding-left-305"> <button [disabled]="employmentBreakList.invalid" type="button"
            class="bofa--button secondary outlined float-padding-margin" #addBreakButtonElement
            (click)="onAddBreak(); scroll(target2)">Add
          break</button>
        </div>
        <div class="width-padding-left-305"> <button [disabled]="employmentList.invalid" type="button"
          class="bofa--button secondary button-font-flex float-padding-margin" #addHistoryButtonElement
          (click)="onAddEmployer(target); scroll(target)">Add
        employer</button>
      </div>
    </div>
  </div>
  <div>
    @if (listCheckEmploymentHistory) {
      <mat-selection-list aria-label="Employee History Selection List"
        aria-disabled="false" aria-describedby="review-employment-horizontal"
        (selectionChange)="handleEmploymentSelection($event, i)">
        @for (employmentForm of employmentList.controls; track employmentForm; let i = $index) {
          <mat-list-option [value]="i"
            [selected]="stepEmployment === i" (click)="scroll(target);focusTargetEmployment()"
            (keyup.enter)="scroll(target);focusTargetEmployment()">
            <div class="is-taller">
              <div class="level">
                <div class="width-padding-margin">
                  @if (!employmentForm.invalid) {
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-label="check icon" class="review-icon">
                        <g data-name="24 x 24 BOX">
                          <rect fill="none" width="24" height="24"/>
                        </g>
                        <g data-name="ICON OUTLINE">
                          <polygon fill="#012169" points="20.216 4 9.781 18.466 3.731 12.475 3.027 13.186 9.908 20 21.027 4.586 20.216 4"/>
                        </g>
                      </svg>
                    </span>
                  }
                  @if (employmentForm.invalid) {
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="review-icon" aria-label="error incomplete employment">
                        <path fill="#e31837" d="M12,2.52,2.52,21.48H21.48Zm0,2.236L19.862,20.48H4.138Z"/>
                        <rect fill="none" width="24" height="24"/>
                      </svg>
                    </span>
                  }
                  <span class="padding-left-10">{{i+1}}</span>
                </div>
                <div class="width-margin-left-right"> @if (employmentForm.controls.isCurrentEmployer.value=='1') {
                  <span
                  > (Current) </span>
                }</div>
                <div class="width-max-overflow-white-padding">
                {{employmentForm.controls.employerName.value}}</div>
                <div class="width-padding-top-bottom">
                  {{employmentForm.controls.employmentStartDate.value | dateFormat }} @if (employmentForm.controls.isCurrentEmployer.value=='0') {
                  <span
                    > @if (employmentForm.controls.employmentEndDate!=null) {
                    <span
                      > -
                    </span>
                  }{{employmentForm.controls.employmentEndDate.value | dateFormat }} </span>
                }
              </div>
            </div>
          </div>
          <mat-divider aria-hidden="true"></mat-divider>
        </mat-list-option>
      }
    </mat-selection-list>
  }
</div>
<div class="is-taller padding-top-20">
  <div class="level">
    <div class="width-padding-left">@if (hasEmploymentBreakHistory()) {
      <span
        class="bofa--heading is-6">Review your employment break
      history</span>
    }
  </div>
</div>
</div>
<div>
  @if (listCheckEmploymentBreak) {
    <mat-selection-list
      (selectionChange)="handleEmploymentBreakSelection($event, i)">
      @for (employmentForm of employmentBreakList.controls; track employmentForm; let i = $index) {
        <mat-list-option [value]="i"
          [selected]="stepEmploymentBreak === i" (click)="scroll(target2)"
          (click)="focusTargetEmploymentBreak()" (keyup.enter)="focusTargetEmploymentBreak()"
          (keyup.enter)="scroll(target2)">
          <div class="is-taller">
            <div class="level">
              <div class="width-padding-left-right-555">
                @if (!employmentForm.invalid) {
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-label="check icon" class="review-icon">
                      <g data-name="24 x 24 BOX">
                        <rect fill="none" width="24" height="24"/>
                      </g>
                      <g data-name="ICON OUTLINE">
                        <polygon fill="#012169" points="20.216 4 9.781 18.466 3.731 12.475 3.027 13.186 9.908 20 21.027 4.586 20.216 4"/>
                      </g>
                    </svg>
                  </span>
                }
                @if (employmentForm.invalid) {
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="review-icon" aria-label="error incomplete employment break">
                      <path fill="#e31837" d="M12,2.52,2.52,21.48H21.48Zm0,2.236L19.862,20.48H4.138Z"/>
                      <rect fill="none" width="24" height="24"/>
                    </svg>
                  </span>
                }
                <span class="padding-left-10">{{i+1}}</span>
              </div>
              <div class="width-margin-left-right"> @if (employmentForm.controls.isCurrentEmploymentStatus.value=='1') {
                <span
                > (Current) </span>
              }</div>
              <div class="width-max-overflow-white-padding">
              {{ getKey(employmentForm.controls.employmentBreakReason.value) }}</div>
              <div class="width-padding-top-bottom">
                {{employmentForm.controls.employmentBreakFromDate.value | dateFormat }} @if (employmentForm.controls.isCurrentEmploymentStatus.value=='0') {
                <span
                  > @if (employmentForm.controls.employmentBreakToDate!=null) {
                  <span
                    > -
                  </span>
                }{{employmentForm.controls.employmentBreakToDate.value | dateFormat }} </span>
              }
            </div>
          </div>
        </div>
        <mat-divider aria-hidden="true"></mat-divider>
      </mat-list-option>
    }
  </mat-selection-list>
}
</div>
</div>
</div>
}
<!-- vertical View -->
@if (employmentChange) {
  <div>
    <div>
      <div class="is-taller  ">
        <div class="level">
          <div class="width-padding-left">
            @if (hasEmploymentHistory()) {
              <h2 id="review-employment-vertical"
              class="bofa--heading is-6 flex-text">Review your employment history</h2>
            }
          </div>
          <div class="width-padding-left-305"> <button [disabled]="employmentBreakList.invalid" type="button"
            class="bofa--button secondary outlined float-padding-margin" #addBreakButtonElement
          (click)="onAddBreak(); scroll(target2)">Add break</button>
        </div>
        <div class="width-padding-left-305"> <button [disabled]="employmentList.invalid" type="button"
          class="bofa--button secondary button-font-flex float-padding-margin" #addHistoryButtonElement
        (click)="onAddEmployer(target); scroll(target)">Add employer</button>
      </div>
    </div>
  </div>
  <div>
    @if (listCheckEmploymentHistory) {
      <mat-selection-list aria-disabled="false"
        aria-label="Employment History Selection List" (selectionChange)="handleEmploymentSelection($event, i)"
        aria-describedby="review-employment-vertical">
        @for (employmentForm of employmentList.controls; track employmentForm; let i = $index) {
          <mat-list-option [value]="i"
            [selected]="stepEmployment === i" (click)="scroll(target);focusTargetEmployment()"
            (keyup.enter)="scroll(target);focusTargetEmployment()">
            <div class="is-taller min-font">
              <div class="level">
                <div class="width-padding-left-right-555">
                  @if (!employmentForm.invalid) {
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-label="check icon" class="review-icon">
                        <g data-name="24 x 24 BOX">
                          <rect fill="none" width="24" height="24"/>
                        </g>
                        <g data-name="ICON OUTLINE">
                          <polygon fill="#012169" points="20.216 4 9.781 18.466 3.731 12.475 3.027 13.186 9.908 20 21.027 4.586 20.216 4"/>
                        </g>
                      </svg>
                    </span>
                  }
                  @if (employmentForm.invalid) {
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="review-icon" aria-label="error incomplete employment">
                        <path fill="#e31837" d="M12,2.52,2.52,21.48H21.48Zm0,2.236L19.862,20.48H4.138Z"/>
                        <rect fill="none" width="24" height="24"/>
                      </svg>
                    </span>
                  }
                  <span class="padding-left-10">{{i+1}}</span>
                </div>
                <div class="width-margin-left-right"> @if (employmentForm.controls.isCurrentEmployer.value=='1') {
                  <span
                  > (Current) </span>
                }</div>
                <div class="width-max-overflow-white-padding">
                {{employmentForm.controls.employerName.value}}</div>
                <div class="width-padding-top-bottom">
                  {{employmentForm.controls.employmentStartDate.value | dateFormat }} @if (employmentForm.controls.isCurrentEmployer.value=='0') {
                  <span
                    > @if (employmentForm.controls.employmentEndDate!=null) {
                    <span
                      > -
                    </span>
                  }{{employmentForm.controls.employmentEndDate.value | dateFormat }} </span>
                }
              </div>
            </div>
          </div>
          <mat-divider aria-hidden="true"></mat-divider>
        </mat-list-option>
      }
    </mat-selection-list>
  }
</div>
<div class="padding-top-50" class="is-taller">
  <div class="level">
    <div class="width-padding-left">@if (hasEmploymentBreakHistory()) {
      <span
        class="bofa--heading is-6">Review your employment break
      history</span>
    }
  </div>
</div>
</div>
<div>
  @if (listCheckEmploymentBreak) {
    <mat-selection-list
      (selectionChange)="handleEmploymentBreakSelection($event, i)">
      @for (employmentForm of employmentBreakList.controls; track employmentForm; let i = $index) {
        <mat-list-option [value]="i"
          [selected]="stepEmploymentBreak === i" (click)="scroll(target2)"
          (click)="focusTargetEmploymentBreak()" (keyup.enter)="focusTargetEmploymentBreak()"
          (keyup.enter)="scroll(target2)">
          <div class="is-taller  min-font">
            <div class="level">
              <div class="width-padding-left-right-555">
                @if (!employmentForm.invalid) {
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-label="check completed employment break" class="review-icon">
                      <g data-name="24 x 24 BOX">
                        <rect fill="none" width="24" height="24"/>
                      </g>
                      <g data-name="ICON OUTLINE">
                        <polygon fill="#012169" points="20.216 4 9.781 18.466 3.731 12.475 3.027 13.186 9.908 20 21.027 4.586 20.216 4"/>
                      </g>
                    </svg>
                  </span>
                }
                @if (employmentForm.invalid) {
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="review-icon" aria-label="error incomplete employment break">
                      <path fill="#e31837" d="M12,2.52,2.52,21.48H21.48Zm0,2.236L19.862,20.48H4.138Z"/>
                      <rect fill="none" width="24" height="24"/>
                    </svg>
                  </span>
                }
                <span class="padding-left-10">{{i+1}}</span>
              </div>
              <div class="width-margin-left-right"> @if (employmentForm.controls.isCurrentEmploymentStatus.value=='1') {
                <span
                > (Current) </span>
              }</div>
              <div class="width-max-overflow-white-padding">
              {{ getKey(employmentForm.controls.employmentBreakReason.value) }}</div>
              <div class="width-padding-top-bottom">
                {{employmentForm.controls.employmentBreakFromDate.value | dateFormat }} @if (employmentForm.controls.isCurrentEmploymentStatus.value=='0') {
                <span
                  > @if (employmentForm.controls.employmentBreakToDate!=null) {
                  <span
                    > -
                  </span>
                }{{employmentForm.controls.employmentBreakToDate.value | dateFormat }} </span>
              }
            </div>
          </div>
        </div>
        <mat-divider aria-hidden="true"></mat-divider>
      </mat-list-option>
    }
  </mat-selection-list>
}
</div>
</div>
</div>
}
</div>
</div>
}
<!-- needed for skip content off focus -->
@if (noEmploymentHistory.value) {
  <div>
    <div class="unClickableDiv">
      <input tabindex="-1" type="text" class="trasparentText">
    </div>
  </div>
}
</form>
} @else {
  Loading Employment history...
}
</div>


@if (jobCountry == 'IND') {
  <div>
    <mat-divider aria-hidden="true"></mat-divider>
    <div class="flex-change fx-flex-40">
      <h2 class="bofa--heading is-4 flex-heading">Required Documentation</h2>
      <p class="padding_8_16_0 has-no-margin"> </p>
      <a href="/bsiAF/api/downloadOUSParentDocument?ousAttachmentID=59&verifyId={{verifyId}}" target="_blank"
        aria-label="accepted documentation for current employment">
      Accepted Documentation for Current Employment </a>
      <p class="padding_8_16_0 has-no-margin"> </p>
      <a href="/bsiAF/api/downloadOUSParentDocument?ousAttachmentID=60&verifyId={{verifyId}}" target="_blank"
        aria-label="accepted documentation for previous employment">
      Accepted Documentation for Previous Employment </a>
    </div>
  </div>
}


